import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=479d96e6&scoped=true"
import script from "./refuse.vue?vue&type=script&lang=js"
export * from "./refuse.vue?vue&type=script&lang=js"
import style0 from "./refuse.vue?vue&type=style&index=0&id=479d96e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d96e6",
  null
  
)

export default component.exports